import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {storeToRefs} from 'pinia';
import {useFeatureFlagStore} from '../../stores/featureFlagStore';
import {useUserStore} from '../../stores/userStore';
import {handleFeatureFlagGuard} from './featureFlagGuard';

export async function beforeEnterApprovalManagement(
    _to: RouteLocationNormalized,
    from: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const {isRoomManager} = storeToRefs(useUserStore());
    if (!isRoomManager.value) {
        return {name: 'Home'};
    }

    const {approvalManagement} = storeToRefs(useFeatureFlagStore());

    return await handleFeatureFlagGuard(approvalManagement, from);
}
